// Package imports:
import React, { useContext} from 'react'
// Component imports:
import LoggedIn from './LoggedIn';
import LoggedOut from './LoggedOut'
// Context imports:
import { UserInfoContext } from '../../../contexts/UserInfoContext';

const NavAccess: React.FC = () => {
    const userInfo = /*{ isAuthenticated: true, name: 'i@i.ii' }*/useContext(UserInfoContext);

    return (
        <nav className="KCL_nav-access">
            <div className='nav-access-content'>
                {(userInfo && userInfo.isAuthenticated)
                    ? <LoggedIn userInfo={userInfo} />
                    : <LoggedOut />
                }
            </div>
        </nav>
    )
}

export default NavAccess
